import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class UrlRedirectService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetUrls(query: {}) {
        return this.baseApiFactory.getData<any[]>('/api/UrlRedirect', query);
    }

    public InsertUrl(value: any) {
        return this.baseApiFactory.post('/api/UrlRedirect', value);
    }

    public UpdateUrl(value: any) {
        return this.baseApiFactory.put('/api/UrlRedirect', value);
    }

    public RemoveUrl(id: string | number) {
        return this.baseApiFactory.delete(`/api/UrlRedirect/${id}`);
    }
}

lazyRegister.service('UrlRedirectService', UrlRedirectService);

